import http from "@/http-common";

class NotificationService {
  getNotifications(params) {
    return http.get("/user/notifications", { params });
  }

  markNotificationsAsRead(id) {
    return http.patch("/user/notifications", {
      notificationId: id,
      isUnread: false,
    });
  }
}

export default new NotificationService();
